module.exports = __webpack_public_path__ + "img/yw.8169ea5d.png";